import { JRCModalLayout } from '../JRCModalLayout';
import { JRCModalContentForm } from '../JRCModalContentForm';
import React from 'react';
import { JRCModalFormProps } from './JRCModal.types';

export const JRCModalForm = ({
    title,
    children,
    options,
    open,
    closeHandler,
    buttons,
    onSubmit,
    loading,
    portalId,
    inPlace,
    ref,
    enableClickAwayCloseModal = false,
    maxHeight,
    zIndex,
}: JRCModalFormProps) => {
    return (
        <JRCModalLayout
            open={open}
            closeHandler={closeHandler}
            portalId={portalId}
            inPlace={inPlace}
            ref={ref}
            enableClickAwayCloseModal={enableClickAwayCloseModal}
            variant={'fixed-height'}
            maxHeight={maxHeight}
            zIndex={zIndex}>
            <JRCModalContentForm
                title={title}
                options={options}
                onSubmit={onSubmit}
                onClickIconClose={closeHandler}
                buttons={buttons}
                loading={loading}
                overflow={'scroll'}>
                {children}
            </JRCModalContentForm>
        </JRCModalLayout>
    );
};
